import { render, staticRenderFns } from "./StepCombinacoesLimites.vue?vue&type=template&id=0733a216&scoped=true"
import script from "./StepCombinacoesLimites.vue?vue&type=script&lang=js"
export * from "./StepCombinacoesLimites.vue?vue&type=script&lang=js"
import style0 from "./StepCombinacoesLimites.vue?vue&type=style&index=0&id=0733a216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733a216",
  null
  
)

export default component.exports